<template>
  <div class="mt-2 flex flex-col">
    <a-checkbox class="mt-4" v-model:checked="modelValue.pause_until_complete">
      Pause until LinkedIn Invite is accepted
    </a-checkbox>

  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: Object, required: true },
});
</script>
